module.exports = __webpack_public_path__ + "img/fivHackDay.9a9ba527.png";